/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsConfigAdvisor extends models.AdditionalResourceDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsConfigAdvisor");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsConfigAdvisor.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsConfigAdvisor>): AdditionalResourceDetailsForFinopsConfigAdvisor {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsConfigAdvisor(), model);
        AdditionalResourceDetailsForFinopsConfigAdvisor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsConfigAdvisor>): AdditionalResourceDetailsForFinopsConfigAdvisor {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsConfigAdvisor.newInstance(<AdditionalResourceDetailsForFinopsConfigAdvisor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsConfigAdvisor) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsConfigAdvisor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsConfigAdvisor): boolean {
        if (models.AdditionalResourceDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsConfigAdvisor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
